import { HttpHeaders } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CompanyService } from 'src/app/api/admin/company/company.service';
import { UbigeoService } from 'src/app/api/config/ubigeo.service';
import { GlobalService } from 'src/app/api/global.service';
import { SearchComponent } from 'src/app/components/search/search.component';
import { environment } from 'src/app/environment';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import SwalAlert from 'src/app/utils/swalalert';
import { ToolsService } from 'src/app/utils/tools.service';
import AlertifyHelper from 'src/app/utils/utils';
declare var $: any;

@Component({
  selector: 'app-company-information',
  templateUrl: './company-information.component.html',
  styleUrls: ['./company-information.component.css']
})
export class CompanyInformationComponent implements OnInit {
  branchofficeSlug = '';
  items: any = [];
  params: any = {
    search: ''
  };
  page = 1;
  count = 0;

  @ViewChild(SearchComponent) searchComponent: any;

  item: FormGroup;
  submitted: boolean = false;
  departmentSelected: any = 0;
  provinceSelected: any = null;
  ubigeoEdit: any = null;
  required_ubigeo: boolean = false;
  // ubigeo data
  departments: any = [];
  provinces: any = [];
  districts: any = [];

  // image logo
  imageUrl: any = null;
  fileUrlImage: any = null;
  // fortmats pdf
  pdfFilePolicies: any | null = null;
  pdfFileRuc: any | null = null;
  pdfFileSummary: any | null = null;
  pdfFileOthers: any | null = null;

  constructor(
    private routeActivated: ActivatedRoute,
    private navigationTrackerService: NavigationTrackerService,
    public fb: FormBuilder,
    private router: Router,
    private companyService: CompanyService,
    private ubigeoService: UbigeoService,
    public toolsService: ToolsService,
    private globalService: GlobalService,
    private alertifyMsg: AlertifyHelper,
    private alert: SwalAlert
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;

    this.item = this.fb.group({
      id: [null],
      social_reason: [null, [Validators.required, Validators.minLength(2)]],
      ruc: [null, [Validators.required]],
      address: [null, [Validators.required]],
      tradename: [null],
      legal_representative: [null],
      cellphone: [null],
      telephone: [null],
      email: [null],
      activity_description: [null],
      offers_description: [null],
      ubigeo: [null],
      url_image: [null],
      url_file_policies: [null],
      url_file_ruc: [null],
      url_file_summary: [null],
      url_file_others: [null]
    });
  }

  ngOnInit() {
    this.list();
    this.getDepartments();
    setTimeout(() => {
      this.navigationTrackerService.initializeMenuAdmin(
        '#tab-company-information'
      );
    }, 150);
    
  }

  list() {
    let val_params = '';
    this.companyService.information(val_params).subscribe({
      next: (data: any) => {
        let data_ = data.results;
        this.item.patchValue({
          id: data_.id,
          social_reason: data_.social_reason,
          ruc: data_.ruc,
          address: data_.address,
          tradename: data_.tradename,
          legal_representative: data_.legal_representative,
          cellphone: data_.cellphone,
          telephone: data_.telephone,
          email: data_.email,
          activity_description: data_.activity_description,
          offers_description: data_.offers_description,
          ubigeo: data_.ubigeo,
          url_image: data_.url_image,
          url_file_policies: data_.url_file_policies,
          url_file_ruc: data_.url_file_ruc,
          url_file_summary: data_.url_file_summary,
          url_file_others: data_.url_file_others
        });

        this.checkUbigeo();
      }
    });
  }

  getDepartments() {
    this.ubigeoService.departments().subscribe({
      next: (data: any) => {
        this.departments = data.results;
      }
    });
  }

  getProvinces(department_code: any) {
    this.ubigeoService.provinces(department_code).subscribe({
      next: (data: any) => {
        this.provinces = data.results;
        this.provinceSelected = null;
        this.required_ubigeo = true;
        if (this.ubigeoEdit != null) {
          this.provinceSelected = this.ubigeoEdit.substr(0, 4);
        }
      }
    });
  }

  getDistricts(department_code: any) {
    this.ubigeoService.districts(department_code).subscribe({
      next: (data: any) => {
        this.districts = data.results;
        this.item.patchValue({
          ubigeo: null
        });

        if (this.ubigeoEdit != null) {
          this.item.patchValue({
            ubigeo: this.ubigeoEdit
          });
        }
      }
    });
  }

  changeDepartment() {
    this.provinceSelected = null;
    this.ubigeoEdit = null;
    this.item.patchValue({
      ubigeo: null
    });
    this.provinces = [];
    this.districts = [];
    if (this.departmentSelected != 0) {
      this.getProvinces(this.departmentSelected);
    }
  }

  changeProvince() {
    this.districts = [];
    this.ubigeoEdit = null;
    this.item.patchValue({
      ubigeo: null
    });
    if (this.toolsService.strToNull(this.provinceSelected) != null) {
      this.getDistricts(this.provinceSelected);
    }
  }

  checkUbigeo() {
    let ubigeo = this.item.value.ubigeo;
    if (ubigeo != null) {
      this.ubigeoEdit = ubigeo;
      this.required_ubigeo = true;
      this.departmentSelected = ubigeo.substr(0, 2);
      this.getProvinces(this.departmentSelected);
      this.getDistricts(ubigeo.substr(0, 4));
    }
  }

  onFileSelected(event: any, model: any): void {
    const file: File = event.target.files[0];
    if (model == 'url_file_policies') {
      if (file && file.type === 'application/pdf') {
        if (this.validateSizeImg(file)) {
          this.pdfFilePolicies = file;
        }
      } else {
        this.pdfFilePolicies = null;
        (<any>$('#file_pdf')).val(null);
        this.alert.warning('Por favor, seleccione un archivo PDF.');
      }
    } else if (model == 'url_file_ruc') {
      if (file && file.type === 'application/pdf') {
        if (this.validateSizeImg(file)) {
          this.pdfFileRuc = file;
        }
      } else {
        this.pdfFileRuc = null;
        (<any>$('#url_file_ruc')).val(null);
        this.alert.warning('Por favor, seleccione un archivo PDF.');
      }
    } else if (model == 'url_file_summary') {
      if (file && file.type === 'application/pdf') {
        if (this.validateSizeImg(file)) {
          this.pdfFileSummary = file;
        }
      } else {
        this.pdfFileSummary = null;
        (<any>$('#url_file_summary')).val(null);
        this.alert.warning('Por favor, seleccione un archivo PDF.');
      }
    } else {
      if (file && file.type === 'application/pdf') {
        if (this.validateSizeImg(file)) {
          this.pdfFileOthers = file;
        }
      } else {
        this.pdfFileOthers = null;
        (<any>$('#url_file_others')).val(null);
        this.alert.warning('Por favor, seleccione un archivo PDF.');
      }
    }
  }

  validateSizeImg(file: any, isMulti: boolean = false) {
    const maxSize = 2048 * 1024; // 2MB in bytes
    if (file) {
      if (file.size / maxSize > environment.max_size_file) {
        let _txt = 'El tamaño del archivo seleccionado (' + file.name + ')';
        this.alertifyMsg.warning(
          _txt +
            ' excede el límite permitido (2 MB). Elija un archivo más pequeño; ó reduzca el tamaño del archivo.',
          10
        );
        return false;
      }
    }

    return true;
  }

  removeFilePdf(model: any) {
    if (model == 'url_file_ruc') {
      this.pdfFileRuc = null;
      this.item.patchValue({
        url_file_ruc: null
      });
    } else if (model == 'url_file_policies') {
      this.pdfFilePolicies = null;
      this.item.patchValue({
        url_file_policies: null
      });
    } else if (model == 'url_file_summary') {
      this.pdfFileSummary = null;
      this.item.patchValue({
        url_file_summary: null
      });
    } else {
      this.pdfFileOthers = null;
      this.item.patchValue({
        url_file_others: null
      });
    }
  }

  onFileSelectedImg(event: any): void {
    const file = event.target.files[0];
    if (this.toolsService.validateSizeImg(file)) {
      this.fileUrlImage = event.target.files[0];
      this.previewImage(file);
    }
  }

  previewImage(file: File): void {
    const reader = new FileReader();
    reader.onload = () => {
      this.imageUrl = reader.result as string;
      this.item.patchValue({
        url_image: null
      });
    };
    reader.readAsDataURL(file);
  }

  onSubmit() {
    this.submitted = true;
    if (this.item.invalid) {
      return;
    }

    let data: any = {};

    if (this.validate()) {
      data.item = this.item.value;
      const formData = new FormData();
      const headers = new HttpHeaders();
      headers.append('Content-Type', 'multipart/form-data');
      headers.append('Accept', 'application/json');
      formData.append('item', JSON.stringify(data));
      formData.append('url_image', this.fileUrlImage);
      formData.append('url_file_ruc', this.pdfFileRuc);
      formData.append('url_file_others', this.pdfFileOthers);
      formData.append('url_file_policies', this.pdfFilePolicies);
      formData.append('url_file_summary', this.pdfFileSummary);

      this.companyService.updateInformation(formData).subscribe({
        next: (data: any) => {
          this.alertifyMsg.success('Registro actualizado con éxito');
          this.list();
        }
      });
    }
  }

  validate() {
    return true;
  }

  refresh() {
    this.imageUrl = null;
    this.fileUrlImage = null;
    this.pdfFilePolicies = null;
    this.list();
  }

  cancel() {
    this.routerBack();
  }

  routerBack() {
    // this.router.navigate([this.branchofficeSlug + '/turismo/tours/lista']);
    this.refresh();
  }
}
